export default __webpack_public_path__ + "fonts/ui-grid.350f396731d728802d286a693bd02017.ttf?";